import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { Toast } from "primeng/toast";
import { CandidateFieldDiffService } from "../../features/candidates/candidate-field-diff/candidate-field-diff.service";
import { SpecialMessageKey } from "../../features/message/message.service";
import { TranslationProposalService } from "../../features/translationProposal/translationProposal.service";
import { ClickCaptureService } from "../click-capture/click-capture.service";
import { TranslateDirective } from "../transloco/translate.directive";

@Component({
  selector: "new-ui-global-toast",
  templateUrl: "./new-ui-global-toast.component.html",
  imports: [TranslateDirective, Toast, NewUiButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiGlobalToastComponent {
  private readonly translationProposalService = inject(TranslationProposalService);
  private readonly candidateFieldDiffService = inject(CandidateFieldDiffService);

  protected readonly specialClassName = ClickCaptureService.specialClassName;
  protected readonly translationProposalKey: SpecialMessageKey = "translation-proposal";
  protected readonly candidateFieldDiffKey: SpecialMessageKey = "candidate-field-diff";

  protected exitTranslationProposal(): void {
    this.translationProposalService.turnOff();
  }

  protected exitCandidateFieldDiff(): void {
    this.candidateFieldDiffService.disable();
  }
}
